
import { defineComponent, PropType, reactive } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'

import { DeliveryCompanyT } from '@/core/types/delivery-companies.types'

import { deliveryCompanies } from '@/core/realisations/delivery-companies.realisation'

import useNotifications from '@/common/composable/useNotifications'
import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: {
        TheButton,
        ButtonDropdown,
    },
    props: {
        item: {
            type: Object as PropType<DeliveryCompanyT>,
            required: true,
        },
    },
    emits: ['deleted'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()
        const notifications = useNotifications()

        const state = reactive({
            is_delete_loading: false,
        })

        const onDelete = async () => {
            const answer = confirm(`Вы действительно хотите удалить компанию ${props.item.name}?`)
            if (!answer) return

            try {
                state.is_delete_loading = true

                await deliveryCompanies.deleteCompany(props.item.id)

                notifications.notify({
                    title: `Компания ${props.item.name} удалена`,
                    type: 'success',
                })
                emit('deleted')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При удалении компании произошла ошибка',
                })
            } finally {
                state.is_delete_loading = false
            }
        }

        return {
            state,
            onDelete,
            havePermissions,
        }
    },
})
